import * as React from "react";
import PropTypes from "prop-types";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";

const options = [
  "Take neutral values",
  "Take from last season",
  'Take from "wettopa"',
  "Guided initialization",
];

export function ConfirmationDialogRaw(props) {
  const {
    onConfirm,
    onCancel,
    errorMessage,
    user,
    value: valueProp,
    open,
    ...other
  } = props;
  const [value, setValue] = React.useState(valueProp);
  const [isSubmitable, setIsSubmitable] = React.useState(false);
  const radioGroupRef = React.useRef(null);

  React.useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };

  const handleCancel = () => {
    onCancel();
  };

  const handleOk = () => {
    onConfirm(value);
  };

  const handleChange = (event) => {
    setValue(event.target.defaultValue);
  };


  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
      maxWidth="xs"
      TransitionProps={{ onEntering: handleEntering }}
      open={open}
      {...other}
    >
      <DialogTitle textAlign="center">Init</DialogTitle>
      <DialogContent dividers>
        <Alert
          sx={{ display: errorMessage !== "" ? "flex" : "none" }}
          severity="error"
        >
          <AlertTitle>Error</AlertTitle>
          {errorMessage}
        </Alert>
        <RadioGroup
          ref={radioGroupRef}
          aria-label="ringtone"
          name="ringtone"
          value={value}
          onChange={handleChange}
        >
          {options.map((option) => {
            var title = option;
            var isDisabled = false;
            try {
              if (option === "Guided initialization") {
                isDisabled = true;
                title = title + " (Under construction)";
              }
            } catch (e) {
              //console.log(e)
            }
            return (
              <FormControlLabel
                value={option}
                key={option}
                disabled={isDisabled}
                control={<Radio />}
                label={title}
              />
            );
          })}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button disabled={!(typeof value === "string")} onClick={handleOk}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmationDialogRaw.propTypes = {
  close: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  user: PropTypes.string.isRequired,
};
